import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
export interface ToastInfo {
  header: string;
  body: string;
  delay?: number;
}
@Injectable({
  providedIn: 'root',
})
export class UserFeedbackService {
  private messageService = inject(MessageService);

  error(title: string, description?: string) {
    this.messageService.add({
      severity: 'error',
      summary: title,
      detail: description,
    });
  }

  success(title: string, description: string) {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: description,
    });
  }

  info(title: string, description?: string) {
    this.messageService.add({
      severity: 'info',
      summary: title,
      detail: description,
    });
  }

  clear() {
    this.messageService.clear();
  }
}
